/**
 * Compass · planejamento semanal dos diretores (porte do protótipo Lovable do CEO).
 *
 * Usa `ConsoleLayout` DIRETO (padrão M365/Relatórios do Service Desk): módulo
 * nascido no design system novo, sem versão Vuetify.
 *
 * ⚠ As DUAS rotas são restritas e independentes (utils/restrictedRoutes.ts e
 * api/src/constants/restrictedRoutes.ts): `/diretoria/compass` é dos diretores e
 * `/diretoria/compass/painel` é só do CEO. Ter a primeira não dá a segunda —
 * cada uma tem concessão própria em /permissions (grupo ou usuário).
 */
import { defineAsyncComponent } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

// Assíncrono: um import estático puxaria o CSS do design system para o bundle de entrada.
const ConsoleLayout = defineAsyncComponent(() => import('@/layouts/console/ConsoleLayout.vue'));

export const compassRoutes: RouteRecordRaw[] = [
  {
    path: '/diretoria/compass',
    component: ConsoleLayout,
    meta: { requiresAuth: true, title: 'Planejamento semanal' },
    children: [
      {
        path: '',
        name: 'CompassDiretor',
        component: () => import('@/views/Diretoria/Compass/CompassPage.vue'),
        meta: { requiresAuth: true, title: 'Planejamento semanal', breadcrumb: 'Diretoria / Planejamento semanal' },
      },
      {
        path: 'painel',
        name: 'CompassPainel',
        component: () => import('@/views/Diretoria/Compass/CompassPainelPage.vue'),
        meta: { requiresAuth: true, title: 'Painel do CEO', breadcrumb: 'Diretoria / Painel do CEO' },
      },
    ],
  },
];

export default compassRoutes;
